import clsx from "clsx";

import { FileUploadSVGIcon } from "components/SVGIcons";
import styles from "./style.module.scss";

type UploadDocumentsButtonProps = {
  label?: string;
  prefixNode?: React.ReactNode;
  className?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export default function UploadDocumentsButton({
  label = "Upload Documents",
  prefixNode,
  className,
  ...buttonProps
}: UploadDocumentsButtonProps) {
  return (
    <button type="button" className={clsx(styles.button, className)} {...buttonProps}>
      {prefixNode ?? <FileUploadSVGIcon className="flex-none desktop:size-8" />}
      {label}
    </button>
  );
}
